import Vue from 'vue'
import Vuex from 'vuex'
import tagsView from './tags-view'
Vue.use(Vuex)

const store = new Vuex.Store({
  tagsView,
  state: {
    /**
     * 问诊详情key
     */
    orderKey: '',
    //考试管理群组信息
    groupList: [],
    // 考试List
    examList: '',
    /**
     * 病例修改数据
     */
    caseItem: {},
    // 考试报告
    debuggingReport: {},
    // 评分记录
    GradingRecords: {},
    // 考试id
    caseId: '',
    // 考试房间id
    RoomId: '',
    // 文档详情
    ImgDeors: {},
    // sp详情
    spDetails: {},
    openedPageRouters: [],
    deleterouter: '',

    // 管理所有对话框的显示状态
    dialogs: {
      dialogA: false,  // 对话框A的显示状态
      dialogB: false,  // 对话框B的显示状态  
      dialogC: false   // 对话框C的显示状态
    },
    // 当前激活的对话框名称
    activeDialog: null
  },
  mutations: {
    // 变更状态的方法 - 必须是同步的
    /**
     * 打开指定对话框
     * @param {Object} state - Vuex的状态对象
     * @param {string} dialogName - 要打开的对话框名称
     */
    OPEN_DIALOG(state, dialogName) {
      console.log('【Vuex】准备打开对话框:', dialogName)

      // 关键步骤1：先关闭所有对话框
      Object.keys(state.dialogs).forEach(key => {
        state.dialogs[key] = false
      })

      // 关键步骤2：打开指定的对话框
      if (state.dialogs.hasOwnProperty(dialogName)) {
        state.dialogs[dialogName] = true
        state.activeDialog = dialogName
        console.log('【Vuex】对话框已打开:', dialogName)
      } else {
        console.error('【Vuex】未知的对话框:', dialogName)
      }
    },
    /**
     * 关闭指定对话框
     */
    CLOSE_DIALOG(state, dialogName) {
      if (state.dialogs.hasOwnProperty(dialogName)) {
        state.dialogs[dialogName] = false
        if (state.activeDialog === dialogName) {
          state.activeDialog = null
        }
        console.log('【Vuex】对话框已关闭:', dialogName)
      }
    },

    /**
     * 关闭所有对话框
     */
    CLOSE_ALL_DIALOGS(state) {
      Object.keys(state.dialogs).forEach(key => {
        state.dialogs[key] = false
      })
      state.activeDialog = null
      console.log('【Vuex】所有对话框已关闭')
    },



    setdeleterouter(state, deleterouter) {
      state.deleterouter = deleterouter || ''
    },
    cleardeleterouter(state) {
      state.deleterouter = ''
    },
    setopenedPageRouters(state, openedPageRouters) {
      state.openedPageRouters = openedPageRouters || []
    },
    clearopenedPageRouters(state) {
      state.openedPageRouters = []
    },
    // * 问诊详情key
    setorderKey(state, orderKey) {
      state.orderKey = orderKey || ''
    },
    clearKey(state) {
      state.orderKey = ''
    },
    //考试管理群组信息
    setgroupList(state, groupList) {
      state.groupList = groupList || []
    },
    cleargroupList(state) {
      state.groupList = []
    },
    // 考试List
    setexamList(state, examList) {
      state.examList = examList || ''
    },
    clearexamList(state) {
      state.examList = ''
    },
    //设置病例修改数据
    setCaseItem(state, caseItem) {
      state.caseItem = caseItem || {}
    },
    clearCaseItem(state) {
      state.caseItem = ''
    },
    //考试报告数据
    setdebuggingReport(state, debuggingReport) {
      state.debuggingReport = debuggingReport || {}
    },
    cleardebuggingReport(state) {
      state.debuggingReport = ''
    },
    //评分记录
    setGradingRecords(state, GradingRecords) {
      state.GradingRecords = GradingRecords || {}
    },
    clearGradingRecords(state) {
      state.GradingRecords = ''
    },
    //考试id
    setcaseId(state, caseId) {
      state.caseId = caseId
    },
    clearcaseId(state) {
      state.caseId = ''
    },
    //考试房间id
    setRoomId(state, RoomId) {
      state.RoomId = RoomId
    },
    //文档详情
    setImgDeors(state, ImgDeors) {
      state.ImgDeors = ImgDeors
    },
    //sp详情
    setspDetails(state, spDetails) {
      state.spDetails = spDetails
    },
  },
  // 动作 - 可以包含异步操作，提交mutation
  actions: {
    /**
     * 打开对话框的动作
     */
    openDialog({ commit }, dialogName) {
      commit('OPEN_DIALOG', dialogName)
    },

    /**
     * 关闭对话框的动作  
     */
    closeDialog({ commit }, dialogName) {
      commit('CLOSE_DIALOG', dialogName)
    },

    /**
     * 关闭所有对话框的动作
     */
    closeAllDialogs({ commit }) {
      commit('CLOSE_ALL_DIALOGS')
    }
  },
  // 获取器 - 从state中派生出一些状态
  getters: {
    // 获取指定对话框的显示状态
    isDialogVisible: (state) => (dialogName) => {
      return state.dialogs[dialogName] || false
    },

    // 获取当前激活的对话框
    getActiveDialog: (state) => {
      return state.activeDialog
    },

    // 检查是否有对话框打开
    hasActiveDialog: (state) => {
      return state.activeDialog !== null
    }
  }
})

export default store